import { render, staticRenderFns } from "./VasionFieldValidationCard.vue?vue&type=template&id=8e0a08a0&scoped=true&"
import script from "./VasionFieldValidationCard.vue?vue&type=script&lang=js&"
export * from "./VasionFieldValidationCard.vue?vue&type=script&lang=js&"
import style0 from "./VasionFieldValidationCard.vue?vue&type=style&index=0&id=8e0a08a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0a08a0",
  null
  
)

export default component.exports